import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import * as React from 'react';

class Languages extends React.Component<any, any> {
  menu = (
    <Menu onSelect={this.props.onSelect} >
      <MenuItem key="nl">NL</MenuItem>
      <MenuItem key="en">EN</MenuItem>
      <MenuItem key="fr">FR</MenuItem>
      <MenuItem key="de">DE</MenuItem>
      <MenuItem key="es">ES</MenuItem>
      <MenuItem key="it">IT</MenuItem>
      <MenuItem key="da">DA</MenuItem>
      <MenuItem key="ar">AR</MenuItem>
    </Menu >
  );

  render() {
    return (
      <Dropdown animation="slide-up" overlay={this.menu}>
        <button className="btn btn-xs dropdown-btn">
          { this.props.language.toUpperCase() } &nbsp;&nbsp;
          <i className="fa fa-caret-down" />
        </button>
      </Dropdown>
    );
  }
}

export default Languages;
